var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoCustSupportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54906 15.4085V12.9752C4.54906 12.1668 5.1824 11.4418 6.0824 11.4418C6.89073 11.4418 7.61573 12.0752 7.61573 12.9752V15.3168C7.61573 16.9418 6.26573 18.2918 4.64073 18.2918C3.01573 18.2918 1.66573 16.9335 1.66573 15.3168V10.1835C1.57406 5.50016 5.27406 1.7085 9.9574 1.7085C14.6407 1.7085 18.3324 5.50016 18.3324 10.0918V15.2252C18.3324 16.8502 16.9824 18.2002 15.3574 18.2002C13.7324 18.2002 12.3824 16.8502 12.3824 15.2252V12.8835C12.3824 12.0752 13.0157 11.3502 13.9157 11.3502C14.7241 11.3502 15.4491 11.9835 15.4491 12.8835V15.4085",
    stroke: "#14141F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoCustSupportActive);
export default __webpack_public_path__ + "static/media/trvto_custSupportActive.c83d704bef4bc00df3a049baba2fe06a.svg";
export { ForwardRef as ReactComponent };